
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attorneys/king",
      function () {
        return require("private-next-pages/attorneys/king/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attorneys/king"])
      });
    }
  